(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("bandResource", ["$resource", bandResource]);
    function bandResource($resource) {
        return $resource("/api/category/:categoryNumber/band/:number/:languageCulture/:action", { action: "@action", categoryNumber: "@categoryNumber", number: "@number", languageCulture: "@languageCulture" }, {
            getIsNameAvailable: {
                method: "GET",
                params: { action: "isAvailable" }
            },
            addLearningPaths: {
                method: "POST",
                params: { action: "learningPaths" },
                isArray: true
            },
            getTranslations: {
                method: "GET",
                params: { action: "translation" }
            },
            saveTranslations: {
                method: "POST",
                params: { action: "translation" }
            },
            removeLearningPath: {
                method: "POST",
                params: { action: "learningPath" }
            }
        });
    }
}());
